<template>
  <BBPTimerModalManual
    :isSave="false"
    :body="body"
    :day="day"
    :startDate.sync="startDate"
    :endDate.sync="endDate"
    :totalTime.sync="totalTime"
  />
</template>

<script>
import moment from 'moment'
import BBPTimerModalManual
  from '@/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalManual/BBPTimerModalManual'
import convertToLocationDate from '@/mixin/convertToLocationDate'

export default {
  name: 'BBPTimerManual',
  components: {
    BBPTimerModalManual
  },
  props: ['input', 'model', 'defaultModel', 'updateBody'],
  mixins: [convertToLocationDate],
  data: () => ({
    day: {
      startDate: new Date()
    },
    endDate: new Date(),
    startDate: new Date(),
    body: {},
    totalTime: 0
  }),
  methods: {
    createDateBackEnd (value) {
      const { startDate } = this.day
      const time = moment(value, ['hh:mm A']).format('HH:mm:ss')
      const date = moment(startDate).format('YYYY-MM-DD')
      const fullDate = `${date}T${time}`
      return this.convertToLocationDate(fullDate)
    },
    setDate () {
      const startDateEndDate = {
        startDate: this.createDateBackEnd(this.startDate),
        endDate: this.createDateBackEnd(this.endDate),
        totalTime: this.totalTime
      }
      this.$emit('input', startDateEndDate)
    },
    setDefaultValue () {
      const { totalTime } = this.defaultModel
      this.totalTime = totalTime
    }
  },
  watch: {
    startDate () {
      this.setDate()
    },
    endDate () {
      this.setDate()
    }
  },
  beforeMount () {
    this.setDefaultValue()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/BBPForm/BBPTimerManual/BBPTimerManual.vue